import { updateLinksAttributes, validateWindowSize, missingWidget } from '../utils.js';

export default function cardsWidget() {
  const widgetName = 'cardsWidget';
  const widgetOpts = typeof cardsWidgetOpts === 'undefined' ? null : cardsWidgetOpts;
  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }
  const isDesktopScreen = validateWindowSize(800);
  const showDescription = false;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    showDescription,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items, showDescription);
      } else {
        $($widget).remove();
      }
    },
  });

  function createCustomCards(widgetData, showDescription) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL } = widgetData[x] || {};
      const $cardItem = $(this);

      $cardItem.attr({
        'data-aos': 'fade-up',
        'data-aos-easing': 'linear',
        'data-aos-duration': '400',
        'data-aos-delay': (x + 1) * 150,
        'data-aos-once': 'true',
        'data-aos-offset': '100',
      });

      $cardItem.append(`
        <div class="card-info">
          <div class="card-title-area">
            <span class="card-title">${Title}</span>
            <span class="card-arrow" aria-hidden="true"></span>
          </div>
          <div class="card-hover-area">
            ${showDescription ? `<p class="widget-description">${Description}</p>` : ''}
            ${URL ? `<a href="${URL}" class="button" ${updateLinksAttributes(URL, 'More')}>More</a>` : ''}
          </div>
        </div>`);

      if (!URL) {
        $cardItem.addClass('void-link').removeAttr('href');
      }
    });
  }
}
